/**
 *
 * @param {object} param0
 * @param {import("./make-start-payload").ResponseData} param0.response
 * @param {string} [param0.message]
 * @returns {string}
 */
export function getErrorMessage({ response, message: baseMessage = "오류가 발생했습니다" }) {
    let { resultCd, resultMsg, advanceMsg } = response?.result || {};

    let messages = [];

    let tag = (() => {
        let tag = [];
        if (resultCd) tag.push(resultCd);
        if (resultMsg) tag.push(resultMsg);

        if (0 < tag.length) return `[${tag.join(":")}]`;
    })();
    if (tag) messages.push(tag);
    if (advanceMsg) messages.push(advanceMsg);

    let message = messages.join(" ");
    if (!message) message = baseMessage;

    return message;
}

export default getErrorMessage;
